import React, { useState, useRef, useEffect } from 'react';
import { gsap } from 'gsap';

function Question({ onAccept }) {
  const [noPosition, setNoPosition] = useState({ x: 0, y: 0 });
  const [yesScale, setYesScale] = useState(1);
  const [attempts, setAttempts] = useState(0);
  const noBtnRef = useRef();
  const yesBtnRef = useRef();

  useEffect(() => {
    if (attempts > 0) {
      gsap.to(yesBtnRef.current, {
        scale: yesScale,
        duration: 0.4,
        ease: 'elastic.out(1, 0.5)'
      });
    }
  }, [yesScale, attempts]);

  const moveNoButton = (e) => {
    const btn = noBtnRef.current;
    if (!btn) return;

    const rect = btn.getBoundingClientRect();
    const btnCenterX = rect.left + rect.width / 2;
    const btnCenterY = rect.top + rect.height / 2;

    // Calculate distance from cursor to button center
    const mouseX = e.clientX || e.touches?.[0]?.clientX;
    const mouseY = e.clientY || e.touches?.[0]?.clientY;
    
    const distanceX = mouseX - btnCenterX;
    const distanceY = mouseY - btnCenterY;
    const distance = Math.sqrt(distanceX * distanceX + distanceY * distanceY);

    // If cursor is within 150px of button, move it slightly away
    if (distance < 150) {
      const angle = Math.atan2(distanceY, distanceX);
      const moveDistance = 80; // Subtle movement
      
      const newX = -Math.cos(angle) * moveDistance;
      const newY = -Math.sin(angle) * moveDistance;

      gsap.to(btn, {
        x: newX,
        y: newY,
        duration: 0.3,
        ease: 'power2.out'
      });

      // Make Yes button bigger
      setAttempts(prev => prev + 1);
      setYesScale(prev => Math.min(prev + 0.15, 1.8));
    }
  };

  const handleYesClick = () => {
    // Celebration
    gsap.to('.question-section', {
      scale: 1.02,
      duration: 0.2,
      yoyo: true,
      repeat: 1,
      ease: 'power2.inOut',
      onComplete: () => {
        setTimeout(onAccept, 300);
      }
    });
  };

  return (
    <section className="question-section" onMouseMove={moveNoButton} onTouchMove={moveNoButton}>
      <div className="question-content">
        <h2 className="question-title">
          Will you be my Valentine?
        </h2>
        <p className="question-subtitle">
          You make every day feel special. I can't imagine celebrating this day with anyone else.
        </p>

        <div className="buttons-wrapper">
          <button
            ref={yesBtnRef}
            className="valentine-btn yes-btn"
            onClick={handleYesClick}
            style={{ transform: `scale(${yesScale})` }}
          >
            Yes! 💕
          </button>

          <button
            ref={noBtnRef}
            className="valentine-btn no-btn"
            onClick={(e) => {
              e.preventDefault();
            }}
          >
            No
          </button>
        </div>

        {attempts > 3 && (
          <p style={{ marginTop: '2rem', opacity: 0.5, fontSize: '1.1rem' }}>
            The button knows you want to say yes 😊
          </p>
        )}
      </div>
    </section>
  );
}

export default Question;